/**
 * @generated SignedSource<<140e3e50ff81949b5bcc1ad4476a084f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateSkillCategoryInput = {
  id: string;
  name?: string | null;
  assignedSkills?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateSkillCategoryMutation$variables = {
  input: UpdateSkillCategoryInput;
};
export type updateSkillCategoryMutation$data = {
  readonly updateSkillCategory: {
    readonly skillCategory: {
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly skills: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly name: string | null;
              readonly category: {
                readonly id: string;
              } | null;
              readonly persons: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly id: string;
                    readonly role: {
                      readonly id: string;
                    } | null;
                    readonly department: {
                      readonly id: string;
                    } | null;
                    readonly active: boolean | null;
                    readonly permissions: ReadonlyArray<string | null> | null;
                  } | null;
                } | null> | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
    readonly skills: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null;
      readonly category: {
        readonly id: string;
      } | null;
    } | null> | null;
  } | null;
};
export type updateSkillCategoryMutation = {
  variables: updateSkillCategoryMutation$variables;
  response: updateSkillCategoryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v1/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillCategory",
  "kind": "LinkedField",
  "name": "category",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateSkillCategoryPayload",
    "kind": "LinkedField",
    "name": "updateSkillCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillCategoryTypeEdge",
        "kind": "LinkedField",
        "name": "skillCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillCategory",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillTypeConnection",
                "kind": "LinkedField",
                "name": "skills",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SkillTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Skill",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PersonTypeConnection",
                            "kind": "LinkedField",
                            "name": "persons",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PersonTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Person",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Role",
                                        "kind": "LinkedField",
                                        "name": "role",
                                        "plural": false,
                                        "selections": (v3/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DepartmentType",
                                        "kind": "LinkedField",
                                        "name": "department",
                                        "plural": false,
                                        "selections": (v3/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "active",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "permissions",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Skill",
        "kind": "LinkedField",
        "name": "skills",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateSkillCategoryMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateSkillCategoryMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "74a4c5f582bebdd3b8048c24446c3526",
    "id": null,
    "metadata": {},
    "name": "updateSkillCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation updateSkillCategoryMutation(\n  $input: UpdateSkillCategoryInput!\n) {\n  updateSkillCategory(input: $input) {\n    skillCategory {\n      node {\n        id\n        name\n        skills {\n          edges {\n            node {\n              id\n              name\n              category {\n                id\n              }\n              persons {\n                edges {\n                  node {\n                    id\n                    role {\n                      id\n                    }\n                    department {\n                      id\n                    }\n                    active\n                    permissions\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    skills {\n      id\n      name\n      category {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac11017c9bb6b4595982add44011749e";

export default node;
